import { keepPreviousData, useQuery, UseQueryResult } from '@tanstack/react-query';
import { getFleets } from 'common/apis/commonApis';
import { useMemo } from 'react';
import { AxiosResponse } from 'axios';

type FleetsPageDataAircrafts = {
    id: number;
    fleet_id: number;
    company_id: number;
    aircraft_number: string;
    added_dt: string;
    added_by_user:number;
    updated_dt: string;
    deleted_status: number;
    recurly_status: number;
    aircraft_id: number;
};

type FleetsPageData = {
    fleet_name: string;
    fleet_id: number;
    first_name: string;
    last_name: string;
    created_by: number;
    company_id: number;
    created_dt: string;
    disabled_aircrafts: FleetsPageDataAircrafts[];
    enabled_aircrafts: FleetsPageDataAircrafts[];
    total_count: number;
};

type GetFleetsPagesData = {
    fleetCount: number;
    rows: FleetsPageData[];
}

type UseUserFleetsResult = {
    query: UseQueryResult<AxiosResponse<GetFleetsPagesData>>;
    rows: FleetsPageData[] | undefined;
}
export function useCompanyFleets(companyId: number): UseUserFleetsResult {
  const key = useMemo(() => [companyId, 'getCompanyFleets'], [companyId]);

  const query = useQuery({
    queryKey: key,
    queryFn: () => getFleets(0, 100, '', '', companyId) as Promise<AxiosResponse<GetFleetsPagesData>>,
    placeholderData: keepPreviousData,
  });

  return {
    query,
    rows: query.data?.data?.rows ?? [],
  };
}
